module.exports = __webpack_public_path__ + "static/media/Managero.30f8c350.png";